export enum RoleTitleEnum {
  ADMIN = "admin",
  OWNER = "owner",
  CLIENT = "client",
  EMPLOYEE = "employee",
}

export enum WeekDayEnum {
  SUNDAY = "Domingo",
  MONDAY = "Segunda-feira",
  TUESDAY = "Terça-feira",
  WEDNESDAY = "Quarta-feira",
  THURSDAY = "Quinta-feira",
  FRIDAY = "Sexta-feira",
  SATURDAY = "Sábado",
}

export enum IntegrationType {
  NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
  TWILIO = "TWILIO",
  OPEN_AI = "OPEN_AI",
}

export enum ModuleTypeEnum {
  CUSTOMER = "CUSTOMER",
  COMPANY = "COMPANY",
  WAITLIST = "WAITLIST",
  SCHEDULING = "SCHEDULING",
  AGENT = "AGENT",
}

export enum MethodTypeEnum {
  POST = "POST",
  PUT = "PUT",
  GET = "GET",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum ChatMessageType {
  USER = "USER",
  BOT = "BOT",
}
